export default __webpack_public_path__ + "static/media/mls-logo.663178f6.png";